import React from "react";
import { useEffect, useState } from "react";
import * as Survey from "survey-react";
import cogoToast from "cogo-toast";
 
import { Spinner } from "reactstrap";
import { getTemplate, saveVisit, listHospitalRooms } from "../../services/Api";
 

import * as browser from "react-device-detect";
import moment from "moment";
import { genericGet, genericPost } from "../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS, LOCAL_PATHS } from "../../Constants";
import { useHistory } from "react-router-dom";

import "survey-react/survey.css";
const AddVisit = (props) => {
  const history = useHistory();
  const { patient, room } = (props.location && props.location.state) || {};
  const [template, settemplate] = useState(null);
  var model = null;
  const [Isloading, setIsloading] = useState(false);
  const [started, setSaterted] = useState("");
  const [ended, setEnded] = useState("2");
  const [tab, settab] = useState(1);

  const [consultationRooms, setconsultationRooms] = useState([]);
  const [to_room_id, setTo_room_id] = useState("");
  const [cycle_id, setCycle_id] = useState(null)
  const [active_cycles, setActive_cycles] = useState([])
  useEffect(() => {
    getVisitTemplate();
    getConsultationRooms();
    list_active_cycles();
    setSaterted(moment(new Date()).format("YYYY-MM-DD HH:MM:00"));

    return () => {};
  }, []);

  const _submit = (form_result) => {
    if (to_room_id == "") {
      alert("Please Select Room ID");
      return;
    }

    console.log(form_result.valuesHash);

 alert(form_result.valuesHash?.scheme)
   
 

    let d = {
      scheme: form_result.valuesHash?.scheme,
      project_id: "900d4917-a5e9-4fd8-bd09-eea8463783cc",
      patient_id: patient?.id,
      parent_id:patient?.parent_id,
      visit_info:  form_result.valuesHash,
      from_room_id: room.room_id,
      to_room_id: to_room_id,

      started_at: started,
      ended_at: moment(new Date()).format("YYYY-MM-DD HH:MM:01"),
 
    };

    console.clear();
    console.log(d);

    setIsloading(true);
    saveVisit(d)
      .then((res) => {
        setIsloading(false);
        var response = res.data;

        console.log(res);
        if (res.status == 200) {
          if (response.status == SUCCESS_RESULT) {
            console.clear();
            console.log(response);
            cogoToast.success("Visit added Successfully", {
              hideAfter: 5,
            });

            history.push({
              pathname: "/hmis/print-visit",
              state: {
                visit: response.data,
              },
            });
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsloading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {
          hideAfter: 5,
        });
      });
  };
  const list_active_cycles = () => {
    
    setIsloading(true)
   
   genericGet(ENDPOINTS.GET_ACTIVE_CYCLES)
   .then((res) => {
     setIsloading(false)
 
       if (res.status == 200) {
           if (res.data.status == SUCCESS_RESULT) {
               let responseData = res.data.data;
               setActive_cycles(responseData);
             
               console.clear();
               console.log(responseData)
         
           } else {
               cogoToast.error(res.data.message, {});
               

           }
       }
   })
   .catch((err) => {
     setIsloading(false)
       cogoToast.error(err, {});

       console.log(err);
   });
  
 };
  const getConsultationRooms = (e) => {
    setIsloading(true);
    listHospitalRooms({ hospital_id: room.hospital_id })
      .then((res) => {
        setIsloading(false);

        if (res.status == 200) {
          var response = res.data;
          if (response.status == SUCCESS_RESULT) {
            setconsultationRooms(response.data);
 
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsloading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {
          hideAfter: 5,
        });
      });
  };

  const getVisitTemplate = () => {
    setIsloading(true);

    getTemplate({ template_name: "visit-registration" })
      .then((res) => {
        console.log(res);
        setIsloading(false);

        if (res.status == 200) {
          var response = res.data;

          let tmp = response.data[0].template;
          settemplate(tmp);
          

          if (response.status == SUCCESS_RESULT) {
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsloading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {
          hideAfter: 5,
        });
      });
  };

  return (
    <div className="card" style={{width:"80%",margin:"auto"}}>
    <div className="card-body">
     <h1>  Add Visit </h1>
 
     <h3>Select Consultation Type</h3>
      <hr />
      <select
        id="consultation_id"
        className="form-control"
        onChange={(e) => setTo_room_id(e.target.value)}
      >
        <option value="">SELECT CONSULTATION ROOM</option>
        {consultationRooms?.map((c, i) => {
          if (c.serial_no == 1) {
            return;
          }
          return <option value={c.id}>{c.name}</option>;
        })}
      </select>

      {/* <h3>Select Payment Scheme</h3>
      <hr />
      <select
        id="cycle_id"
        className="form-control"
        onChange={(e) => setCycle_id(e.target.value)}
      >
        <option value="">SELECT PAYMENT SCHEME</option>
        {active_cycles?.map((c, i) => {
         
          return <option value={c.cycle_id}>{c.cycle_name}</option>;
        })}
      </select> */}


 
      <div className="d-flex justify-content-center my-1">
        {Isloading && <Spinner />}
      </div>
      {template != null && (
        <Survey.Survey json={template} data={patient}
        
        onCompleting={(survey, options) => {
          options.allowComplete = false;
          survey.clear(false, true);
if(to_room_id==""){
cogoToast.error("Please select Consultation Type")
} else
{
  _submit(survey);
}
       
          
        }}
        showCompletedPage={false}
        
        onComplete={(survey) =>{  
          survey.clear(false, true);
          _submit(survey);
       
        
        }} />
      )}
    </div>
    </div>

  );
};

export default AddVisit;
